import { getFirebaseIdToken } from '../service/firebaseBridge';
import { getAccessToken, getLegacyContext } from '../service/authRuntime';
import { AuthBodyType } from '../types';

// Compatibility adapter for legacy APIs. Its state is deliberately memory-only.
const getAttToken = async (forceRefresh: boolean): Promise<AuthBodyType | null> => {
  const accessToken = getAccessToken();
  const context = getLegacyContext();
  if (!accessToken || !context) return null;
  try {
    // getIdToken() is managed by the Firebase SDK and refreshes an expired ID token
    // using the Firebase refresh token. Do not cache its result in this adapter.
    const firebaseIdToken = await getFirebaseIdToken(accessToken, forceRefresh);
    return { userToken: firebaseIdToken, username: context.username, userEmpresa: context.userEmpresa };
  } catch {
    return null;
  }
};

const AttToken = () => getAttToken(false);

export const refreshAttToken = () => getAttToken(true);

export default AttToken;
